<template>
  <el-dialog
    title="渠道授信申请资料清单"
    :visible.sync="isShow"
    destroy-on-close
    width="880px"
    @close="closeDialog"
  >
    <div class="box">
      <el-table :data="approvalHistoryData" style="width: 100%; height: 100%;">
        <el-table-column prop="index" label="序号">
          <template slot-scope="{ $index: index }">
            {{ index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="nodeDesc" label="渠道授信申请资料清单" />
      </el-table>
    </div>
    <div class="dialog-footer">
      <el-button class="btn" @click="closeDialog">
        知道了
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      isShow: false,
      approvalHistoryData: [
        { nodeDesc: '客户申请表' },
        { nodeDesc: '企业简介' },
        { nodeDesc: '法人代表和实际控制人身份证复印件、个人简历' },
        { nodeDesc: '营业执照副本（三证合一）' },
        { nodeDesc: '公司章程复印件（有工商局备案章）' },
        { nodeDesc: '开票信息' },
        { nodeDesc: '开户行许可证' },
        { nodeDesc: '最新的公司验资报告（发生股权变更或转让应提供证明文件）' },
        { nodeDesc: '企业最新的银行征信报告,以及法人代表、实际控制人及担保人个人征信记录（近3个月）' },
        { nodeDesc: '企业注册地、生产经营用地 / 用房的使用证 / 产权证或租赁合同复印件' },
        { nodeDesc: '企业近三年审计报告（新成立公司提供成立之日至今的报告即可,无审计报告请提供年底财务报表）' },
        { nodeDesc: '企业近三个月资产负债表、损益表、现金流量表' },
        { nodeDesc: '企业近三年增值税，企业所得税纳税申报表；最近一期增值税，企业所得税纳税申报表。' },
        { nodeDesc: '主要账户银行一年对账单，现金流水统计表' },
        { nodeDesc: '提供法定代表人和主要股东夫妻双方身份证复印件、婚姻状况证明、户口本及个人财产清单和证明文件' }
      ],
      visibleLoading: false
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
    },

    closeDialog () {
      this.isShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  border: 1px solid #EBEEF5;
}
.dialog-footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .btn{
    width: 100px;
    height: 35px;
  }
}

:deep(.el-dialog__title){
  font-size: 16px !important;
}
:deep(.el-dialog__body){
  padding-bottom: 15px;
}
:deep(.el-table__body .el-table__row:nth-last-child(1) .el-table__cell){
  border: 0;
}
:deep(.el-table::before){
  height: 0 !important;
}
:deep(.el-dialog__header){
  background-color: #fff;
  border-bottom: 1px solid #EBEEF5;
}
</style>
